import { MobXProviderContext } from 'mobx-react';
import React from 'react';

export class MobxHooksError extends Error {}

const useStore = <T>(store: string): T => {
  const stores = React.useContext(MobXProviderContext) || new Object();
  if (!(store in stores)) {
    throw new MobxHooksError(`[bz-stores - useStore]: '${store}' has not been provided`);
  }

  return stores[store] as T;
};

export default useStore;
